import request from "@/libs/request";
import { appName } from "../../config/url";

/**
 * 我的教室页面
 * 获取学员全部作业信息列表
 */
export const getUserHomework = (appname: any) => {
    appname.appName = appName;
    return request({
        url: "/homework/work/list/user",
        method: "post",
        data: appname
    });
};

/**
 * 用户上传作业地址
 */
export const userUpload = () => {
    return "/api/homework/work/upload";
};
//学生端通知待办事项
export const getMessageList = (userMeg: any) => {
    return request({
        url: "/edge/message/list",
        method: "post",
        data: userMeg
    });
};
// 修改消息已读状态
export const changeReadState = (messageId: number) => {
    return request({
        url: "/edge/message/read/id",
        method: "get",
        params: {
            messageId
        }
    });
};

// 修改消息已读状态（根据业务主键）
export const changeRelevanceState = (
    messageClassify: string,
    relevanceKey: string,
    userId: number
) => {
    return request({
        url: "/edge/message/read/relevance",
        method: "get",
        params: {
            messageClassify,
            relevanceKey,
            userId
        }
    });
};
